import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "aggregatedSkillDashborad",
  class: "scrollBar scrollableDiv"
}
const _hoisted_2 = {
  border: "1",
  id: "dashboardTable",
  class: "table-hover dashboardTable",
  style: {"height":"auto"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("colgroup", { id: "dashboardColGroupTbl" }, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"140px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"140px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"140px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"100px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"100px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"60px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"60px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"60px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"60px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"60px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"60px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"60px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"60px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"60px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"60px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"60px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"60px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"60px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"60px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"60px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"60px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"60px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"70px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"60px"} })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", { id: "dashboardHeaderTbl" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "5",
      class: "dasboardTitle facilityCol",
      style: {"padding":"3px"}
    }, "Aggregated Skills Dashboard"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "5",
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "Patient Census"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "Premium Labor"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "6",
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "Nursing"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "6",
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "Support")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "1",
      class: "drivingHeader facilityCol",
      style: {"padding":"3px"}
    }, "Facility"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "1",
      class: "drivingHeader clusterCol",
      style: {"padding":"3px"}
    }, "Cluster"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "1",
      class: "drivingHeader deptNameCol",
      style: {"padding":"3px"}
    }, "Department"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "1",
      class: "drivingHeader deptCodeCol",
      style: {"padding":"3px"}
    }, "Code"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "1",
      class: "drivingHeader shiftCol",
      style: {"padding":"3px"}
    }, "Shift Summary"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "1",
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "Fore"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "1",
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "Actual"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "1",
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "StaffTo"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "1",
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "1:1 Stable"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "1",
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "1:1 Unstable"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "1",
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "OT"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "1",
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "C/L"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "1",
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "RN Min-Max"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "1",
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "RN EXP < 1yr"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "1",
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "Chg RN"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "1",
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "RN"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "LPN"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "1",
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "Resource RN"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "S Min-Max"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "PCT"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "Clerical"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "Clinical Tech"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "detailsHeader",
      style: {"padding":"3px","width":"70px"}
    }, "Specialists"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "detailsHeader",
      style: {"padding":"3px"}
    }, "FAN/EVS")
  ])
], -1)
const _hoisted_5 = { id: "dashboardBodyTbl" }
const _hoisted_6 = ["facilityid", "rowspan"]
const _hoisted_7 = ["clusterid", "rowspan"]
const _hoisted_8 = ["departmentid", "rowspan"]
const _hoisted_9 = ["departmentid", "rowspan"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick", "departmentname", "departmentid"]
const _hoisted_12 = ["departmentname", "departmentid"]
const _hoisted_13 = ["onClick", "departmentname", "departmentid"]
const _hoisted_14 = ["departmentname", "departmentid"]
const _hoisted_15 = ["departmentname", "departmentid"]
const _hoisted_16 = ["title", "onClick", "departmentname", "departmentid"]
const _hoisted_17 = ["onClick", "departmentname", "departmentid"]
const _hoisted_18 = ["departmentname", "departmentid"]
const _hoisted_19 = ["title", "onClick", "departmentname", "departmentid"]
const _hoisted_20 = ["title", "onClick", "columnname", "departmentname", "departmentid"]
const _hoisted_21 = ["departmentname", "departmentid"]
const _hoisted_22 = ["title", "onClick", "columnname", "departmentname", "departmentid"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 3 }
const _hoisted_27 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!
  const _component_ContractLaborCalloutPopup = _resolveComponent("ContractLaborCalloutPopup")!
  const _component_Actionable = _resolveComponent("Actionable")!
  const _component_StaffToForecastCensus = _resolveComponent("StaffToForecastCensus")!
  const _component_PremiumLaborBreakdown = _resolveComponent("PremiumLaborBreakdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("tbody", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboardData, (facility) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: facility }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(facility.Clusters, (cluster, cindex) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: cindex }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cluster.Departments, (department, dindex) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: dindex }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(department.Summaries, (summary, sindex) => {
                      return (_openBlock(), _createElementBlock("tr", { key: sindex }, [
                        (cindex == 0 && dindex == 0 && sindex == 0)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 0,
                              facilityid: facility.FacilityId,
                              class: "drivingHeader facilityCol",
                              rowspan: facility.TotalRows
                            }, _toDisplayString(facility.FacilityName), 9, _hoisted_6))
                          : _createCommentVNode("", true),
                        (dindex == 0 && sindex == 0)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 1,
                              clusterid: cluster.ClusterId,
                              class: "drivingHeader clusterCol",
                              rowspan: cluster.TotalRows
                            }, _toDisplayString(cluster.ClusterName), 9, _hoisted_7))
                          : _createCommentVNode("", true),
                        (sindex == 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createElementVNode("td", {
                                departmentid: department.DepartmentId,
                                class: "drivingHeader deptNameCol",
                                rowspan: department.TotalRows
                              }, _toDisplayString(department.DepartmentName), 9, _hoisted_8),
                              _createElementVNode("td", {
                                departmentid: department.DepartmentId,
                                class: "drivingHeader deptCodeCol",
                                rowspan: department.TotalRows
                              }, _toDisplayString(department.DepartmentCode), 9, _hoisted_9)
                            ], 64))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", {
                          class: "drivingHeader shiftCell shiftCol",
                          onClick: ($event: any) => (_ctx.showActionable(summary.DepartmentSummaryId, summary.StartDateTime, 1))
                        }, _toDisplayString(_ctx.getSummaryTime(summary.StartDateTime)), 9, _hoisted_10),
                        _createElementVNode("td", {
                          class: "gridStandard forecastcensus",
                          style: {"mso-number-format":"'@'"},
                          onClick: ($event: any) => (_ctx.showEditStaffToForecastCensus(summary.DepartmentSummaryId, summary.StartDateTime)),
                          columnname: "Fore",
                          departmentname: department.DepartmentName,
                          departmentid: department.DepartmentId
                        }, _toDisplayString(summary.Metrics[0].ForecastCensus), 9, _hoisted_11),
                        _createElementVNode("td", {
                          class: "gridStandard actual-census",
                          style: {"mso-number-format":"'@'"},
                          columnname: "Actual",
                          departmentname: department.DepartmentName,
                          departmentid: department.DepartmentId
                        }, _toDisplayString(summary.Metrics[0].ActualCensus != null ? summary.Metrics[0].ActualCensus : '-'), 9, _hoisted_12),
                        _createElementVNode("td", {
                          class: "gridStandard staffto",
                          style: {"mso-number-format":"'@'"},
                          onClick: ($event: any) => (_ctx.showEditStaffToForecastCensus(summary.DepartmentSummaryId, summary.StartDateTime)),
                          columnname: "StaffTo",
                          departmentname: department.DepartmentName,
                          departmentid: department.DepartmentId
                        }, _toDisplayString(summary.Metrics[0].StaffTo!= null ? summary.Metrics[0].StaffTo : '-'), 9, _hoisted_13),
                        _createElementVNode("td", {
                          class: "gridStandard",
                          style: {"mso-number-format":"'@'"},
                          columnname: "1:1 Stable",
                          departmentname: department.DepartmentName,
                          departmentid: department.DepartmentId
                        }, _toDisplayString(_ctx.getStableCount(summary.Metrics)), 9, _hoisted_14),
                        _createElementVNode("td", {
                          class: "gridStandard",
                          style: {"mso-number-format":"'@'"},
                          columnname: "1:1 Unstable",
                          departmentname: department.DepartmentName,
                          departmentid: department.DepartmentId
                        }, _toDisplayString(_ctx.getUnstableCount(summary.Metrics)), 9, _hoisted_15),
                        _createElementVNode("td", {
                          class: _normalizeClass(['gridStandard ', _ctx.getOverTimeCalculationCSS(summary.Metrics)]),
                          style: {"mso-number-format":"'@'"},
                          title: _ctx.getOverTimeCalculationTitle(summary.Metrics),
                          onClick: ($event: any) => (_ctx.showActionable(summary.DepartmentSummaryId, summary.StartDateTime, 1)),
                          columnname: "OT",
                          departmentname: department.DepartmentName,
                          departmentid: department.DepartmentId
                        }, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.getOverTimeCalculation(summary.Metrics)), 1)
                        ], 10, _hoisted_16),
                        _createElementVNode("td", {
                          class: _normalizeClass(['gridStandard ', _ctx.getCLOverTimeCalculationCSS(summary.Metrics)]),
                          style: {"mso-number-format":"'@'"},
                          onClick: ($event: any) => (_ctx.loadPremiumLaborBreakdownPopupOnCLClick(summary.DepartmentSummaryId, summary.StartDateTime)),
                          columnname: "C/L",
                          departmentname: department.DepartmentName,
                          departmentid: department.DepartmentId
                        }, [
                          _createElementVNode("span", null, _toDisplayString(summary.Metrics[0].StaffCountsByPL), 1)
                        ], 10, _hoisted_17),
                        _createElementVNode("td", {
                          class: "gridStandard w60",
                          style: {"mso-number-format":"'@'"},
                          columnname: "RN Min-Max",
                          departmentname: department.DepartmentName,
                          departmentid: department.DepartmentId
                        }, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.getRNMinMax(summary.Metrics)), 1)
                        ], 8, _hoisted_18),
                        _createElementVNode("td", {
                          class: _normalizeClass(['gridStandard ', _ctx.getRNExpLess1YrCss(summary.Metrics[0])]),
                          style: {"mso-number-format":"'@'"},
                          title: _ctx.getRNExpLess1YrTitle(summary.Metrics[0]),
                          onClick: ($event: any) => (_ctx.showActionable(summary.DepartmentSummaryId, summary.StartDateTime, 1)),
                          columnname: "RN EXP < 1yr",
                          departmentname: department.DepartmentName,
                          departmentid: department.DepartmentId
                        }, [
                          _createElementVNode("span", null, _toDisplayString(summary.Metrics[0].RNExperienceLt1), 1)
                        ], 10, _hoisted_19),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nursingSkills, (nsSkill) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: nsSkill,
                            class: _normalizeClass([_ctx.getValueBySkillGroupCss(nsSkill, summary.Metrics)]),
                            style: {"mso-number-format":"'@'"},
                            title: _ctx.getValueBySkillGroupTitle(nsSkill, summary.Metrics),
                            onClick: ($event: any) => (_ctx.showActionable(summary.DepartmentSummaryId, summary.StartDateTime, 2)),
                            columnname: nsSkill,
                            departmentname: department.DepartmentName,
                            departmentid: department.DepartmentId
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.getValueBySkillGroup(nsSkill, summary.Metrics)), 1)
                          ], 10, _hoisted_20))
                        }), 128)),
                        _createElementVNode("td", {
                          class: "gridStandard",
                          style: {"mso-number-format":"'@'"},
                          columnname: "S Min-Max",
                          departmentname: department.DepartmentName,
                          departmentid: department.DepartmentId
                        }, _toDisplayString(summary.Metrics[0].SMin + " - " + (summary.Metrics[0].SMax === _ctx.maxCensusEntry ? _ctx.maxCensusValue : summary.Metrics[0].SMax )), 9, _hoisted_21),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supportSkills, (spSkill) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: spSkill,
                            class: _normalizeClass([_ctx.getValueBySkillGroupCss(spSkill, summary.Metrics)]),
                            style: {"mso-number-format":"'@'"},
                            title: _ctx.getValueBySkillGroupTitle(spSkill, summary.Metrics),
                            onClick: ($event: any) => (_ctx.showActionable(summary.DepartmentSummaryId, summary.StartDateTime, 2)),
                            columnname: spSkill,
                            departmentname: department.DepartmentName,
                            departmentid: department.DepartmentId
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.getValueBySkillGroup(spSkill, summary.Metrics)), 1)
                          ], 10, _hoisted_22))
                        }), 128))
                      ]))
                    }), 128))
                  ], 64))
                }), 128))
              ], 64))
            }), 128))
          ], 64))
        }), 128))
      ])
    ]),
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isContractLaborCalloutVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createVNode(_component_ContractLaborCalloutPopup, {
            contractLaborCalloutDetails: _ctx.contractLaborCalloutDetails,
            contractLaborCalloutFlags: _ctx.contractLaborCalloutFlags,
            onCloseModal: _ctx.closeCrtLbrCalloutPopup
          }, null, 8, ["contractLaborCalloutDetails", "contractLaborCalloutFlags", "onCloseModal"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isActionableModelVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createVNode(_component_Actionable, {
            actionableConfig: _ctx.actionableData,
            onCloseModal: _ctx.closeActionablePopup
          }, null, 8, ["actionableConfig", "onCloseModal"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isStafToForecastModelVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createVNode(_component_StaffToForecastCensus, {
            staffToForecastInput: _ctx.staffToForecastData,
            onCloseModal: _ctx.closeStaffToForecastPopup
          }, null, 8, ["staffToForecastInput", "onCloseModal"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isPremiumLaborBreakdownVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createVNode(_component_PremiumLaborBreakdown, {
            onCloseModal: _ctx.closePremiumLaborBreakdownPopup,
            premLaborBreakdownInput: _ctx.premLaborBreakdownInput,
            isBreakdownfrom7Day: false
          }, null, 8, ["onCloseModal", "premLaborBreakdownInput"])
        ]))
      : _createCommentVNode("", true)
  ]))
}